// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const productionConfig = {
  apiKey: "AIzaSyBhncSzoIJ4JoLwC5PPhbKQs5wosXk6V-I",
  authDomain: "oilmed-a6dc6.firebaseapp.com",
  projectId: "oilmed-a6dc6",
  storageBucket: "oilmed-a6dc6.firebasestorage.app",
  messagingSenderId: "672202503987",
  appId: "1:672202503987:web:c7dfb8426b237c658b7046",
  measurementId: "G-S62YKFC067",
};

// Projet de staging (copie de la prod pour tester avant déploiement).
// Config de l'app web « OilMed Staging Web » du projet oilmed-staging.
const stagingConfig = {
  apiKey: "AIzaSyCOX0z6FHLlNUSZHfVD42VX_fCCBmpsK8c",
  authDomain: "oilmed-staging.firebaseapp.com",
  projectId: "oilmed-staging",
  storageBucket: "oilmed-staging.firebasestorage.app",
  messagingSenderId: "1033171259893",
  appId: "1:1033171259893:web:40b091b70062ad0e68d0bc",
};

// REACT_APP_ENV=staging est défini par `npm run build:staging` / `start:staging`
export const IS_STAGING = process.env.REACT_APP_ENV === "staging";
const firebaseConfig = IS_STAGING ? stagingConfig : productionConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, "us-central1");

/*const googleProvider = new GoogleAuthProvider();
const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const logInWithEmailAndPassword = async (email, password) => {
  try {
    return await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const registerWithEmailAndPassword = async (name, email, password) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await addDoc(collection(db, "users"), {
      uid: user.uid,
      name,
      authProvider: "local",
      email,
    });
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
const logout = async () => {
  try {
    await signOut(auth);

    console.log("SIGN OUT");
    return true;
  } catch (err) {
    console.error(err);
    alert(err.message);
    return false;
  }
};

export {
  auth,
  db,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  logout,
  storage,
};*/

const logOut = async () => {
  try {
    await signOut(auth);

    console.log("SIGN OUT");
    return true;
  } catch (err) {
    console.error(err);
    alert(err.message);
    return false;
  }
};

export { auth, db, storage, functions, logOut };
